export default __webpack_public_path__ + "images/ZS.27b6cba.png";